






import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import SimpleSlider from "../Widgets/SimpleSlider.vue";
import EventApi from "../../api/EventsApi";

@Component({
    components: {SimpleSlider},
})

export default class SliderModal extends Vue {
    @Prop({required: true}) private readonly images!: Array<string>;

    mounted(): void
    {

    }

    private closeModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('close');
    }
}

